import { Dispatch } from 'redux'

export const CLEAR_ACCOUNT_SEARCH = 'CLEAR_ACCOUNT_SEARCH'

export const clearAccountSearch = (dispatch: Dispatch) =>
  dispatch({ type: CLEAR_ACCOUNT_SEARCH })
